<div class="content-wrapper table-full-bx">
    <div class="page-content account-settings">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">  
                        <div class="ibox-body">
                                <div class="iboxcontent">
                                    <h3>Account Settings</h3>                                              
                                </div>
                                <!-- Account settings  -->
                                <div class="row">
                                    <div class="col-md-12 col-lg-3 col-sm-12">
                                          <!-- Tabs nav -->
                                        <div class="nav nav-pills nav-pills-custom pills-custom">
                                              <a class="nav-link mb-3 p-3 "  href="javascript:void(0);" routerLink="/account-settings/change-password">
                                                  <span  class=" ">Change password</span>
                                              </a>
                          
                                              <a class="nav-link mb-3 p-3 active " href="javascript:void(0);" routerLink="/account-settings/notification" >
                                                 
                                                  <span class=" ">Notifications</span>
                                              </a>
                          
                                              <a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/save-card"  *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'" hidden>
                                      
                                                  <span class=" ">Saved cards</span>
                                              </a>
                          
                                            
                          
                                              <a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/inventory-history" *ngIf="userDatas?.Recruiter?.userType == 'SUPER_RECRUITER' || (userDatas?.Recruiter?.userType == 'SUB_RECRUITER' && userPermissionData?.viewActivePlans == 1)" >
                                              
                                                  <span class="">Subscriptions</span>
                                              </a>
                                              <a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/billing-address" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'" >
                                      
                                                <span class=" ">Billing address</span>
                                            </a>
                  
                                            <a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/my-templates" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'" >
                                      
                                              <span class=" ">My templates</span>
                                          </a>
                                           
                                            </div>
                                    </div>
                          
                                      <div class="col-lg-5 tabwidth marginstart">
                                          <!-- Tabs content -->
                                          <div class="tab-content" id="v-pills-tabContent">
                                              <div class="tab-pane fade  bg-box show active " >
                                                
                                                <div class=" subHeader">
                                                    <h2 class="mainTitle">Notifications</h2>
                                            
                                                </div>

                                               
                                                    <div class="notificationbar on-off">
                                                        <p>Send notifications on email</p>
                                                        <label class="switch" (change)="emailNotification($event)">
                                                            <input type="checkbox" [checked]="isNotificationSetting == 0">
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </div>

                                                    <div class="notificationbar on-off" hidden>
                                                        <p>Send notifications on SMS</p>
                                                        <label class="switch" (change)="smsNotification($event)">
                                                            <input type="checkbox" [checked]="isNotificationSMSSetting == 0">
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </div>

                                            

                                    
                                      
                                            </div>
                                              </div>
                                                
                                      </div>
                                         
                                      </div>
                                <!-- End -->
                        </div>
                </div>
            </div>
        </div>                    
    </div>
</div>    
